/* =============================================================
   D'Avila — Substituição dinâmica de cupom por influencer
   =============================================================
   Se cliente entrou via ?ref=CODIGO (capturado por davila-quickadd.js
   e salvo em localStorage), este script:
   - Substitui o CÓDIGO exibido nos badges de cupom (cards + PDP)
   - Substitui a % pelo INFLUENCER_DISCOUNT_PCT (padrão global)
   - Recalcula o preço com desconto usando a % nova
   - Ajusta return_to (form da PDP) pra aplicar o cupom novo

   Preserva o preço riscado original (compare_at) intacto.
   Nao aplica cupom automatico via redirect — cliente cola manual.

   Config: INFLUENCER_DISCOUNT_PCT altera aqui pra mudar globalmente.
   ============================================================= */
(function () {
  'use strict';

  var INFLUENCER_DISCOUNT_PCT = 7; // % padrao pra qualquer cupom de influencer (alinhado ao DAVILA7)

  function getRefCoupon() {
    return typeof window.davilaGetRefCoupon === 'function'
      ? window.davilaGetRefCoupon()
      : null;
  }

  function parseMoneyBRL(text) {
    if (!text) return null;
    // "R$ 399,90" -> 399.90
    var cleaned = String(text)
      .replace(/[^\d,.\-]/g, '')
      .replace(/\.(?=\d{3}(\D|$))/g, '') // remove separador de milhar
      .replace(',', '.');
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  function formatMoneyBRL(value) {
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  function replaceInBlock(block, refCode, pct) {
    // Substitui codigo em qualquer .davila-card__coupon-code do bloco
    var codes = block.querySelectorAll('.davila-card__coupon-code');
    codes.forEach(function (el) { el.textContent = refCode; });

    // Substitui % em qualquer .davila-card__coupon-off do bloco
    var offs = block.querySelectorAll('.davila-card__coupon-off');
    offs.forEach(function (el) { el.textContent = '-' + pct + '%'; });
  }

  function recalculatePrice(container, pct) {
    // Card usa .davila-card__price / .davila-card__price-compare
    // PDP usa .davila-price-value / .davila-price-original-cupom
    var compareEl = container.querySelector('.davila-card__price-compare')
      || container.querySelector('.davila-price-original-cupom');
    var priceEl = container.querySelector('.davila-card__price')
      || container.querySelector('.davila-price-value');
    if (!compareEl || !priceEl) return;
    var original = parseMoneyBRL(compareEl.textContent);
    if (!original) return;
    // Trunca (nao arredonda) pra bater com a divisao inteira do Liquid.
    // Sem isso, 558,07 * 0,93 dava 519,0051 -> arredondado 519,01 (quebra o "redondo").
    // Com floor: 51900 / 100 = 519,00.
    var newPrice = Math.floor(original * (100 - pct)) / 100;
    // Preserva filhos: substitui só nodes de texto (PDP tem <span> com id/aria)
    var formatted = formatMoneyBRL(newPrice);

    // Pix (PDP): 2o desconto sobre o preco ja com cupom, em centavos e truncando
    // igual ao Liquid. Sem isso o Pix ficava com o cupom antigo ao trocar pro do influencer.
    var pixEl = container.querySelector('.davila-price-pix-value');
    if (pixEl) {
      var pixPct = parseInt(pixEl.getAttribute('data-pix-pct'), 10) || 0;
      var cuponCents = Math.floor(Math.round(original * 100) * (100 - pct) / 100);
      var pixCents = Math.floor(cuponCents * (100 - pixPct) / 100);
      // Pra cima ate o real inteiro, igual ao Liquid (nunca anuncia menos do que o Luna cobra)
      pixCents = Math.ceil(pixCents / 100) * 100;
      pixEl.textContent = formatMoneyBRL(pixCents / 100);
    }
    if (priceEl.children.length === 0) {
      priceEl.textContent = formatted;
    } else {
      // Se tem filhos (raro), sobrescreve todo pra garantir
      priceEl.textContent = formatted;
    }
  }

  function updateReturnToInputs(refCode) {
    // Na PDP: input[name="return_to"] pode ter /discount/DAVILA7?redirect=/cart
    // Substitui pelo cupom do influencer.
    var inputs = document.querySelectorAll('input[name="return_to"]');
    inputs.forEach(function (input) {
      var val = input.value || '';
      if (val.indexOf('/discount/') === 0) {
        input.value = '/discount/' + encodeURIComponent(refCode) + '?redirect=/cart';
      }
    });
  }

  function apply() {
    var refCode = getRefCoupon();
    if (!refCode) return;

    // Cards (home, coleções, produtos relacionados)
    var cards = document.querySelectorAll('.davila-card__coupon-badge');
    cards.forEach(function (badge) {
      // O badge esta dentro do bloco .davila-card__prices (ou similar) que
      // tambem contem .davila-card__price. Sobe ate encontrar o container.
      var container = badge.closest('.davila-card__prices') || badge.parentElement;
      if (container) {
        replaceInBlock(badge, refCode, INFLUENCER_DISCOUNT_PCT);
        recalculatePrice(container, INFLUENCER_DISCOUNT_PCT);
      }
    });

    // PDP tem o mesmo padrao mas usa classe adicional davila-price-coupon
    var pdpBadges = document.querySelectorAll('.davila-price-coupon');
    pdpBadges.forEach(function (badge) {
      var container = badge.closest('.davila-price-block') || badge.parentElement;
      if (container) {
        replaceInBlock(badge, refCode, INFLUENCER_DISCOUNT_PCT);
        recalculatePrice(container, INFLUENCER_DISCOUNT_PCT);
      }
    });

    updateReturnToInputs(refCode);

    console.log('[davila-influencer-coupon] aplicado codigo=' + refCode + ' pct=' + INFLUENCER_DISCOUNT_PCT + '% em ' + (cards.length + pdpBadges.length) + ' bloco(s)');
  }

  // Roda ao carregar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // Roda quando cart atualiza (caso a UI recarregue cards)
  document.addEventListener('cart:updated', apply);

  // Expõe pra debug
  window.davilaApplyInfluencerCoupon = apply;
})();
